import { useParams } from "react-router-dom"
import "./index.less"
import { CommonTabbarContext, SystemContext, TabContext } from "@/App";
import { DEVICE_TYPE } from "@/enums/device-type";
import { TAB_TYPE } from "@/enums/tab-type";
import { useContext, useEffect, useState } from "react";
import { CommonTabbarState, TabRoute } from "@/global/components/common-tabbar";
import { GlobalDataBox } from "@/global/interface/lib-device/global-data-box";
import { getGlobalDataBoxDetail } from "@/api/lib/lib-data-box";
import { Skeleton } from "antd";
import { getDataBoxTypeName } from "@/enums/data-box-type";
import { SystemStatus } from "@/global/store/system-store";
import { getSignalTypeName } from "@/enums/signal-type";

interface IProps {
    dataBoxId: number
    needRender: boolean
}

export default function LibDataBoxPanel(props: IProps) {
    const [globalDataBox, setGlobalDataBox] = useState<GlobalDataBox>(null); // 采集箱
    const [loading, setLoading] = useState<boolean>(false); // loading

    // 初始化
    useEffect(() => {
        if (!props.dataBoxId) return;
        setLoading(true)
        getGlobalDataBoxDetail(+props.dataBoxId).then(res => {
            let data: GlobalDataBox = res.data || null;
            setGlobalDataBox(data);
        }).finally(() => {
            setLoading(false);
        })
    }, [props.dataBoxId, props?.needRender])

    
    return (
        <div className="lib-data-box-container">
            <Skeleton loading={loading}>
                <div className="title">
                    {globalDataBox?.name || '采集箱'}
                </div>
                <div className="main">
                    <div className="item">
                        <div className="item-name">类型</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {getDataBoxTypeName(globalDataBox?.type)}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">型号</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalDataBox?.marking || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">厂商</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalDataBox?.manufacturer || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">通道数量</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalDataBox?.channelCount || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">信号类型</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {getSignalTypeName(globalDataBox?.signalType) || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">自动推送数据</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalDataBox?.autoPush ? '是' : '否'}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">独立传感器</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalDataBox?.sensorStandalone ? '是' : '否'}
                            </div>
                        </div>
                    </div>
                </div>
            </Skeleton>
        </div>
    )
}